import { createGlobalStyle } from "styled-components";
import { COLOR_TEXT_GRAY, COLOR_DEEP_FOREST, COLOR_MANIFEST_TEAL, COLOR_ERROR } from "./globalStylesVariables";
import SuisseRegular from "./sussie/suisseintl-regular_0.otf";
import SuisseLightItalic from "./sussie/Suisse Int'l Light Italic.otf";
import SuisseSemiBoldItalic from "./sussie/Suisse Int'l Semi Bold Italic.otf";
import SuisseBold from "./sussie/SuisseIntl-Bold.otf";
import SuisseMedium from "./sussie/SuisseIntl-Medium.ttf";

const GlobalStyles = createGlobalStyle`
  @font-face {
      font-family: 'Suisse';
      url(${SuisseLightItalic}) format('opentype');
      font-weight: 300;
      font-style: italic;
  }

  @font-face {
      font-family: 'Suisse';
      src: url(${SuisseSemiBoldItalic}) format('opentype');
      font-weight: 600;
      font-style: italic;
  }

  @font-face {
      font-family: 'Suisse';
      src: url(${SuisseBold}) format('opentype');
      font-weight: 700;
      font-style: normal;
  }

  @font-face {
      font-family: 'Suisse';
      src: url(${SuisseMedium}) format('truetype');
      font-weight: 500;
      font-style: normal;
  }

  @font-face {
      font-family: 'Suisse';
      src: url(${SuisseRegular}) format('opentype');
      font-weight: 400;
      font-style: normal;
  }

  
  @keyframes drop-in-list {
    from {  transform: translateY(50px);
    opacity:0;
    }
    to {transform: translateY(0);
    opacity:1;}
  }
  
  .drop-in-item{
    transform: translateY(50px);
    opacity:0;
    animation-name: drop-in-list;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    }
    
  *{
    margin: 0;
    padding:0;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: 'Suisse', sans-serif;
    font-size: 14px;
    line-height: 1.35;
  }

  .sandbox-banner{
    text-align: center;
    position:fixed;
    height: 30px;
    top:0;
    left:0;
    right: 0;
    background:gray;
    color:white;
    font-size:16px;
    line-height: 30px;
  }
  
  // Transition styles
  .fade-enter  {
    opacity: 0;
    transform: translateY(20%);
  }
  .fade-enter-active  {
    opacity: 1;
    transform: translateY(0%);
  }
  .fade-exit  {
    opacity: 1;
    transform: translateY(0%);
  }
  
  .fade-exit-active  {
    opacity: 0;
    transform: translateY(-15%);
  }
  
  .fade-enter-active,
  .fade-exit-active {
    transition: all 0.35s ease-in-out;
  }
  
  .fade {
    opacity:0;
    transform: translateY(-5%);
    transition: all 0.20s ease-in-out;
  }
  .fade-entered{
    opacity: 1;
    transform: translateY(0);
  
  }
  
  .fade-exited{
    opacity:0;
    transform: translateY(5%);
  }

  h1 {
    color: ${COLOR_DEEP_FOREST};
    font-size: 28px;
    line-height: 1.42;
    font-weight: 500;
  }

  h2 {
    color: ${COLOR_DEEP_FOREST};
    font-size: 20px;
    line-height: 1.3;
    font-weight: 500;
  }

  h3 {
    color: ${COLOR_DEEP_FOREST};
    font-size: 16px;
    line-height: 1.31;
    font-weight: 500;
  }
  
  p {
    color: ${COLOR_TEXT_GRAY};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
  }

  /* width */
  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: none;
    border-radius: 10px;
    margin-block:16px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #babcc2;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #9fa1a7;
  }

  .text-center {
    text-align: center;
  }

  .text-gray{
    color: ${COLOR_TEXT_GRAY} 
  }

  .text-medium{
    font-weight: 500;
  }

  .text-deep-forest{
    color: ${COLOR_DEEP_FOREST};
  }

  .text-manifest-teal{
    color: ${COLOR_MANIFEST_TEAL}};

  .text-error{
    color: ${COLOR_ERROR};
  };

  .pl-16{
    padding-left:16px;
  }

  .pr-16{
    padding-right:16px;
  }

  .pt-20{
  padding-top: 20px !important;
  }

  .pl-20{
    padding-left:20px !important;
  }

  .pr-20{
    padding-right:20px !important;
  }

  .pr-0{
    padding-right: 0 !important;
  }

  .pl-0{
    padding-left: 0 !important;
  }

  .support-link {
    color: ${COLOR_MANIFEST_TEAL};
    text-decoration: none;
    width: 300px;
  }

  .consent-pane__list-group .consent-pane__list-group__item{
      transform: translateY(50px);
      opacity:0;
      animation-name: drop-in-list;
      animation-duration: 1s;
      animation-fill-mode: forwards;

    &:nth-child(1){
      animation-delay:0.15s;
    }
    &:nth-child(2){
      animation-delay:0.9s;
    }
      &:nth-child(3){
      animation-delay:1.65s;
    }
  }

`;

export default GlobalStyles;
